import { parseDroplinkParam } from 'src/shared/shared.service';
import { C05MulticolumnCTAProps } from './C05MulticolumnCTA';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ColumnCtaProps, MultiColumnCtaProps } from '@ahc-digital/component-library';
import { C05MulticolumnCTAsProps } from './C05MulticolumnCTAs';
import { MULTI_COLUMN_CTA_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateMultiColumnCTAModel(props?: C05MulticolumnCTAProps) {
  const { renderRichText, renderText, renderLink } = useConditionalRendering();
  const headlineTag =
    (props?.params?.TitleType &&
      (parseDroplinkParam(props?.params?.TitleType)?.value
        ?.value as MultiColumnCtaProps['headlineTag'])) ||
    'p';

  const textAlignment =
    (props?.params?.TitleAlignment &&
      (parseDroplinkParam(props?.params?.TitleAlignment)?.value
        ?.value as ColumnCtaProps['textAlignment'])) ||
    'left';

  return {
    textAlignment,
    headline: renderText(props?.fields?.Headline),
    headlineTag,
    bodyCopy: renderRichText(props?.fields?.BodyCopy),
    extraCTA: renderLink(props?.fields?.ExtraCTA),
  };
}

export function CreateMultiColumnCTAsModel(props?: C05MulticolumnCTAsProps) {
  const { renderRichText, renderText } = useConditionalRendering();
  const columns =
    (props?.params?.NumberOfColumns &&
      (parseDroplinkParam(props?.params?.NumberOfColumns)?.value
        ?.value as MultiColumnCtaProps['columns'])) ||
    '2';

  const backgroundColor =
    (props?.params?.Theme &&
      (parseDroplinkParam(props?.params?.Theme)?.value
        ?.value as MultiColumnCtaProps['backgroundColor'])) ||
    'white';

  const headlineTag =
    (props?.params?.TitleType &&
      (parseDroplinkParam(props?.params?.TitleType)?.value
        ?.value as MultiColumnCtaProps['headlineTag'])) ||
    'p';

  const textAlignment =
    (props?.params?.TitleAlignment &&
      (parseDroplinkParam(props?.params?.TitleAlignment)?.value
        ?.value as MultiColumnCtaProps['textAlignment'])) ||
    'left';

  return {
    backgroundColor,
    headline: renderText(props?.fields?.Headline),
    headlineTag,
    supportingCopy: renderRichText(props?.fields?.SupportCopy),
    textAlignment,
    columns,
    ctas: props?.rendering ? (
      <Placeholder name={MULTI_COLUMN_CTA_CONTAINER} rendering={props?.rendering} />
    ) : (
      <></>
    ),
  };
}
